













import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'ThirdPaySuc'
})
export default class ThirdPaySuc extends Vue {
  created() {
    document.title = '支付成功';
    
  }
}
